import { render, staticRenderFns } from "./modal-recipient-input-databases-table.vue?vue&type=template&id=680eabd2&"
import script from "./modal-recipient-input-databases-table.vue?vue&type=script&lang=js&"
export * from "./modal-recipient-input-databases-table.vue?vue&type=script&lang=js&"
import style0 from "./modal-recipient-input-databases-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports